import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import Typography$1 from "../../../node_modules/@mui/material/Typography/Typography.es.js";
function Typography(props) {
  return /* @__PURE__ */ jsx(Typography$1, { ...props });
}
export {
  Typography
};
//# sourceMappingURL=typography.es.js.map
